import React from 'react';
import MyBetsLayout2 from './my-bets-layout-2/MyBetsLayout2';
import { getConfiguration } from '../utils';
import MyBetsLayout1 from './MyBetsLayout1';
import MyBetsLayout3 from './my-bets-layout-3/MyBetsLayout3';


function MyBets(props) {
	const conf = getConfiguration();
	const layoutVersion = conf.mbt ?? 'V1';

	let LayoutComponent;

	switch (layoutVersion) {
		case 'V1':
			LayoutComponent = MyBetsLayout1;
			break;
		case 'V2':
			LayoutComponent = MyBetsLayout2;
			break;
		case 'V3':
			LayoutComponent = MyBetsLayout3;
			break;
		default:
			LayoutComponent = MyBetsLayout1;
	}

	return (
		<>
			<LayoutComponent {...props} />
		</>
	);

}

export default MyBets;